<template>
  <div class="app-container">
    <div class="group-list-filter">
      <el-row>
        <el-col :span="6">
          <el-input class="group-list-filter-value" size="small" placeholder="分组名称" suffix-icon="el-icon-search" clearable v-model.trim="search.name" @keyup.enter.native="getList"></el-input>
        </el-col>
        <el-col :span="18">
          <el-button class="group-list-filter-reset" size="small" @click="getList">立即筛选</el-button>
          <el-button class="group-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
        </el-col>
      </el-row>
    </div>

    <basic-container>
      <avue-crud 
        ref="crud"
        :option="tableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        @sort-change="handleSortChange">

        <template slot="isActive" slot-scope="scope" >
          <span>{{ scope.row.isActive ? '是' : '否' }}</span>
        </template>
        <template slot="creatorName" slot-scope="scope" >
          <span>{{ scope.row.creatorName || 'system' }}</span>
        </template>        

        <template slot="menuLeft">
          <el-button v-if="permissions.medal_group_add" type="primary" icon="el-icon-plus" size="small" @click="openAddDialog">新增</el-button>
          <el-button v-if="permissions.medal_cache_sync" type="primary" icon="el-icon-refresh" @click="handleSyncCache" size="small">同步</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button v-if="permissions.medal_group_edit" type="text" icon="el-icon-edit" size="mini" @click="openEditDialog(scope.row)">编辑</el-button>
          <el-button v-if="permissions.medal_group_del" type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>

      </avue-crud>
    </basic-container>

    <el-dialog
      title="新增分组"
      :visible.sync="addMedalGroupDialog"
      @close="closeAddDialog"
      :close-on-click-modal="false"
      width="30%"
      class="handle-dialog">
        <el-form ref="addMedalGroupFrom" :model="addMedalGroupFrom" :rules="rules">
            <el-form-item prop="name">
              <el-label>分组名称:</el-label>
              <el-input type="text" placeholder="请输入分组名称" v-model="addMedalGroupFrom.name" clearable></el-input>
            </el-form-item>
            <el-form-item prop="isActive">
              <el-label >是否在用户端显示:</el-label>
              <el-select placeholder="是否在用户端显示" v-model="addMedalGroupFrom.isActive" clearable size="small">
                <el-option
                  v-for="item in medalGroupActiveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="sort">
              <el-label>排序:</el-label><br/>
              <el-input-number controls-position="right" v-model="addMedalGroupFrom.sort" :precision="0"></el-input-number>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button class="handle-dialog-footer-cancel" @click="closeAddDialog">取消</el-button>
              <el-button type="primary" class="handle-dialog-footer-save" @click="handleAdd">确定</el-button>
            </div>
        </el-form>
    </el-dialog>
    <el-dialog
      title="编辑分组"
      :visible.sync="editMedalGroupDialog"
      @close="closeEditDialog"
      :close-on-click-modal="false"
      width="30%"
      class="handle-dialog">
        <el-form ref="editMedalGroupFrom" :model="editMedalGroupFrom" :rules="rules">
            <el-form-item prop="name">
              <el-label>分组名称:</el-label>
              <el-input type="text" placeholder="请输入分类名称" v-model="editMedalGroupFrom.name" clearable></el-input>
            </el-form-item>
            <el-form-item prop="isActive">
              <el-label>是否在用户端显示:</el-label>
              <el-select placeholder="是否在用户端显示" v-model="editMedalGroupFrom.isActive" clearable size="small">
                <el-option
                  v-for="item in medalGroupActiveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="sort">
              <el-label>排序:</el-label><br/>
              <el-input-number controls-position="right" v-model="editMedalGroupFrom.sort" :precision="0"></el-input-number>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button class="handle-dialog-footer-cancel" @click="closeEditDialog">取消</el-button>
              <el-button type="primary" class="handle-dialog-footer-save" @click="handleEdit">确定</el-button>
            </div>
        </el-form>
    </el-dialog>
  </div>  
</template>

<script>
import { medalGroupsTableOption } from '@/const/crud/medal/group';
import { getMedalGroupPage, syncMedalGroupCache, addGroupObj, updateGroupObj, deleteMedalGroupById } from '@/api/medal/medal';
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      tableLoading: false,
      tableOption: medalGroupsTableOption,
      tableData: [],
      search: {
        current: 1,
        size: 10,
        sortField: '',
        sortPolicy: '',
        name: '',
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },      
      addMedalGroupDialog: false,
      editMedalGroupDialog: false,
      addMedalGroupFrom: {
        name: '',
        isActive: null,
        sort: 0,
      },
      editMedalGroupFrom: {
        id: null,
        name: '',
        isActive: null,
        sort: 0,
      },
      rules: {
        name: [
          { required: true, message: '分组名称不能为空', trigger: 'blur' },
          { max: 20, message: '长度不超过 20 个字符', trigger: 'blur' }
        ],
        isActive: [
          { required: true, message: '请选择是否在用户端显示', trigger: 'change' }
        ],
        sort: [
          { required: true, message: '请填写排序优先级', trigger: 'change' }
        ],
      },
      medalGroupActiveOptions: [
        { label: '是', value: true },
        { label: '否', value: false },
      ],                
    }
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  activated () {
    this.getList();
  },
  created () {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size,
        name: this.search.name,
      };
      if (this.search.sortField) {
        params.sortField = this.search.sortField;
      } else {
        params.sortField = 'sort';
      }
      if (this.search.sortPolicy) {
        params.sortPolicy = this.search.sortPolicy;
      } else {
        params.sortPolicy = 'asc';
      }

      this.tableLoading = true;
      getMedalGroupPage(params).then(response => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
        this.tableLoading = false;
      })      
    },
    handleAdd() {
      this.$refs.addMedalGroupFrom.validate((valid) => {
        if (!valid) return
        addGroupObj(this.addMedalGroupFrom).then(res => {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.addMedalGroupDialog = false;
          this.getList();
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除【' + row.name + '】这个勋章分组吗? 分组删除后，该分组下的所有勋章将自动设置为“未分组”。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMedalGroupById(row.id).then(response => {
          if (response.data.data) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList();
          }
        }).catch(error => {
          this.$message({
            message: error,
            type: 'error'
          })
        })
      }).catch(function () {
      })
    },
    handleEdit() {
      this.$refs.editMedalGroupFrom.validate((valid) => {
        if (!valid) return
        this.editMedalGroupDialog = false;
        updateGroupObj(this.editMedalGroupFrom).then(res => {
          this.$message({
            message: '编辑成功',
            type: 'success'
          })
          this.getList();
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    handleSyncCache() {
      var _this = this;
      _this.$confirm('请确认是否需要同步勋章分组缓存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(function () {
        return syncMedalGroupCache();
      }).then(() => {
        _this.$message({
          showClose: true,
          message: '同步成功',
          type: 'success',
        });
      }).catch(function (err) {
        if (err == 'cancel') {
          return;
        }
        _this.$message({
          showClose: true,
          message: '同步失败',
          type: 'error',
        });
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.search.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.search.size = val;
      this.getList();
    },
    handleSortChange(val) {
      if (val.prop == 'inserted_time') {
        this.search.sortField = 'inserted_time';
      } else if (val.prop == 'sort') {
        this.search.sortField = 'sort';
      } else {
        this.search.sortField = '';
      }
      if (val.order == 'ascending') {
        this.search.sortPolicy = 'asc';
      } else if (val.order == 'descending') {
        this.search.sortPolicy = 'desc';
      } else {
        this.search.sortPolicy = '';
      }
      this.getList();
    },
    searchReset() {
      this.page.currentPage = 1;
      this.page.pageSize = this.search.size;
      this.search.current = 1;
      this.search.name = '';
      this.getList();
    },
    openEditDialog(row) {
      this.editMedalGroupFrom.id = row.id;
      this.editMedalGroupFrom.name = row.name;
      this.editMedalGroupFrom.isActive = row.isActive;
      this.editMedalGroupFrom.sort = row.sort;
      this.editMedalGroupDialog = true;
    },
    openAddDialog() {
      this.addMedalGroupDialog = true;
    },
    closeAddDialog() {
      this.$refs.addMedalGroupFrom.resetFields();
      this.addMedalGroupDialog = false;
    },    
    closeEditDialog() {
      this.$refs.editMedalGroupFrom.clearValidate();
      this.editMedalGroupDialog = false;
    },
  },
}
</script>

<style  lang="scss" scoped>
.group-list-filter {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border: none;
    font-size: 14px;
  }
  &-value {
    width: 96% !important;
  }
  &-search {
    float: right;
    margin-right: 8px;
  }
  &-reset {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
.handle-dialog {
  display: flex;
  flex-direction: column;
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 50px 0px;
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
  }
</style>